import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import VarietyPage from './components/VarietyPage';
import SeedManager from './components/admin/SeedManager';
import AdminLogin from './components/admin/AdminLogin';
import useStore from './store/useStore';
import './App.css';

function App() {
  const { isAuthenticated, userRole } = useStore();

  // Determine default route based on role
  const getDefaultRoute = () => {
    if (!isAuthenticated) return '/login';
    return userRole === 'packing' ? '/qr' : '/seeds';
  };

  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Public route - Variety page */}
          <Route path="/variety/:varietyCode" element={<VarietyPage />} />

          {/* Login route */}
          <Route
            path="/login"
            element={isAuthenticated ? <Navigate to={getDefaultRoute()} /> : <AdminLogin />}
          />

          {/* Seed management routes */}
          <Route
            path="/seeds"
            element={isAuthenticated ? <SeedManager view="list" /> : <Navigate to="/login" />}
          />
          <Route
            path="/seeds/edit/:id"
            element={isAuthenticated ? <SeedManager view="form" /> : <Navigate to="/login" />}
          />
          <Route
            path="/seeds/create"
            element={isAuthenticated ? <SeedManager view="form" /> : <Navigate to="/login" />}
          />

          {/* QR Code routes */}
          <Route
            path="/qr"
            element={isAuthenticated ? <SeedManager view="qrcode" /> : <Navigate to="/login" />}
          />
          <Route
            path="/qr/:varietyCode"
            element={isAuthenticated ? <SeedManager view="qrcode" /> : <Navigate to="/login" />}
          />

          {/* Legacy /admin routes - redirect to new routes */}
          <Route path="/admin/login" element={<Navigate to="/login" replace />} />
          <Route path="/admin" element={<Navigate to={getDefaultRoute()} replace />} />
          <Route path="/admin/seeds" element={<Navigate to="/seeds" replace />} />
          <Route path="/admin/seeds/edit/:id" element={<Navigate to="/seeds/edit/:id" replace />} />
          <Route path="/admin/seeds/create" element={<Navigate to="/seeds/create" replace />} />
          <Route path="/admin/qr" element={<Navigate to="/qr" replace />} />
          <Route path="/admin/qr/:varietyCode" element={<Navigate to="/qr/:varietyCode" replace />} />

          {/* Default redirect based on authentication and role */}
          <Route path="/" element={<Navigate to={getDefaultRoute()} />} />

          {/* 404 Not Found */}
          <Route path="*" element={<div className="not-found">
            <h2>Page Not Found</h2>
            <p>The requested page could not be found.</p>
          </div>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
